"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPackagesMonitor = void 0;
/* eslint-disable @typescript-eslint/no-floating-promises */
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var actions_1 = require("../state/actions");
var actions_2 = require("@app/features/dashboard/state/actions");
var config_1 = require("@app/shared/config");
var log_1 = __importDefault(require("@app/shared/log"));
// Global Constants
var COMPONENT_NAME = 'NewPackagesMonitor';
var REFRESH_INTERVAL = 60000;
var NewPackagesMonitor = /** @class */ (function (_super) {
    __extends(NewPackagesMonitor, _super);
    function NewPackagesMonitor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timerId = 0;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.refreshNewPackages = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log_1.default.info('Refreshing new packages', COMPONENT_NAME);
                        return [4 /*yield*/, Promise.resolve(this.props.onRefreshPackageCache('latest'))];
                    case 1:
                        _a.sent();
                        if (this.props.latestNumUpdatedPackages > 0) {
                            this.props.onResetNewPackages(config_1.Config.DEFAULT_PAGE_SIZE, this.props.savedSearchTerm ? this.props.savedSearchTerm : '', this.props.isViewingWorkgroup, true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setRefreshTimeout = function () {
            _this.refreshNewPackages();
            _this.timerId = window.setTimeout(_this.setRefreshTimeout, REFRESH_INTERVAL);
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    NewPackagesMonitor.prototype.componentDidMount = function () {
        this.timerId = window.setTimeout(this.setRefreshTimeout, REFRESH_INTERVAL);
    };
    NewPackagesMonitor.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timerId);
    };
    /* Component Methods - End */
    NewPackagesMonitor.prototype.render = function () {
        if (!this.props.isActive) {
            window.clearTimeout(this.timerId);
        }
        return null;
    };
    return NewPackagesMonitor;
}(react_1.Component));
exports.NewPackagesMonitor = NewPackagesMonitor;
var mapStateToProps = function (store) {
    return {
        isViewingWorkgroup: store.newPackages.viewingWorkgroup,
        latestNumUpdatedPackages: store.dash.latestNumUpdatedPackages ? store.dash.latestNumUpdatedPackages : -1,
        savedSearchTerm: store.packageDetails.savedSearchTerm
    };
};
var mapDispatchToProps = {
    onRefreshPackageCache: actions_2.refreshPackageCache,
    onResetNewPackages: actions_1.resetNewPackages
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NewPackagesMonitor);
